export const passwordFieldPattern = /(?=.*?[A-Z])(?=.*[a-z])(?=.*?[#?!@$%^&*-])/;
